import React from 'react'
import { getTranslation } from '../translations'

function SectionHeader({ title, subtitle }) {
  return (
    <div className="mb-2">
      <div className="bg-[#134225] text-white font-extrabold px-3 py-2 uppercase tracking-wide text-sm text-center">{title}</div>
      {subtitle ? (
        <div className="text-[12px] italic text-[#334c3e] px-2 py-1 text-center">{subtitle}</div>
      ) : null}
    </div>
  )
}

function StageRow({ stage, inputs, isFirst }) {
  return (
    <>
      {inputs.map((input, idx) => (
        <tr key={`${stage}-${idx}`} className="odd:bg-white even:bg-gray-50 text-sm">
          {idx === 0 && (
            <td 
              className="px-3 py-3 border border-[#e4ebe7] font-bold align-top" 
              rowSpan={inputs.length}
            >
              {stage}
            </td>
          )}
          <td className="px-3 py-3 border border-[#e4ebe7]">{input.input}</td>
          <td className="px-3 py-3 border border-[#e4ebe7]">{input.dose}</td>
          <td className="px-3 py-3 border border-[#e4ebe7]">{input.method}</td>
        </tr>
      ))}
    </>
  )
}

export default function FertilizerRecommendation({
  title,
  subtitle,
  stages = [],
  language = 'english',
}) {
  const t = getTranslation(language)
  const sectionTitle = title || t.section3Title
  const sectionSubtitle = subtitle || t.section3Subtitle
  
  // Check if stages data is available and valid
  const hasValidStages = stages && Array.isArray(stages) && stages.length > 0
  
  // If no valid stages data, show error message
  if (!hasValidStages) {
    return (
      <div className="mt-6">
        <SectionHeader title={sectionTitle} subtitle={sectionSubtitle} />
        <div className="border border-[#cbd9d2] rounded-md overflow-hidden bg-yellow-50">
          <div className="px-6 py-8 text-center">
            <div className="text-yellow-800 font-semibold text-lg mb-2">
              {t.fertilizerNotAvailable}
            </div>
            <p className="text-yellow-700 text-sm">
              {t.fertilizerNotAvailableDesc}
            </p>
          </div>
        </div>
      </div>
    )
  }
  
  return (
    <div className="mt-6">
      <SectionHeader title={sectionTitle} subtitle={sectionSubtitle} />
      <div className="border border-[#cbd9d2] rounded-md overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="bg-[#134225] text-white text-sm">
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.stage}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.input}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.dose}</th>
              <th className="px-3 py-2 border border-[#d9e4dd] text-left">{t.method}</th>
            </tr>
          </thead>
          <tbody>
            {stages.map((stage, i) => (
              <StageRow key={stage.stage} stage={stage.stage} inputs={stage.inputs} isFirst={i === 0} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
